export const AWAITED_ACTION_LIST_SUCCESS = "AWAITED_ACTION_LIST_SUCCESS";
export const AWAITED_ACTION_LIST_ERROR = "AWAITED_ACTION_LIST_ERROR";
export const AWAITED_ACTION_LIST_START = "AWAITED_ACTION_LIST_START";